import { css } from "@emotion/css";
export const StatusIconStyles = css({
    width: 20,
    height: 20,
    fill: "currentcolor",
    display: "block",
});
